<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px">
    <el-form :model="modelForm" ref="formRef" :rules="rules" label-width="auto">
      <el-form-item label="试卷名称：" prop="name" class="model-input">
        <el-input
          maxlength="30"
          v-model="modelForm.name"
          placeholder="请输入试卷名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="试卷等级：" prop="courseLevel" class="model-input">
        <el-select
          v-model="modelForm.courseLevel"
          placeholder="请选择试卷等级"
          style="width: 100%;"
        >
          <el-option
            v-for="item in examLevel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="submitFunc"
        v-loading="submitLoading"
        :disabled="submitLoading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { createInfo, editInfo, getInfo } from "@/api/handsOnPaper.js";
import { examLevel } from "@/utils/dict.js";
import { debounce } from "lodash";
export default {
  data() {
    return {
      examLevel,
      dialogVisible: false,
      dialogType: "",
      dialogTitle: "",
      modelForm: {
        name: "",
        courseLevel: ""
      },
      submitLoading: false,
      rules: {
        name: [{ required: true, message: "请输入试卷名称", trigger: "blur" }],
        courseLevel: [
          { required: true, message: "请选择试卷等级", trigger: "blur" }
        ]
      },
      submitFunc: null
    };
  },
  computed: {},
  methods: {
    async open(type, id) {
      this.dialogVisible = true;
      if (this.$refs.formRef) this.$refs.formRef.resetFields();

      this.dialogType = type;
      this.dialogTitle = type == "edit" ? "编辑" : "新增";
      if (type == "edit") {
        const res = await getInfo(id);
        this.modelForm = res.data.data;
      }
    },

    async submitForm() {
      console.log(this.submitLoading);
      if (this.submitLoading) return;
      this.submitLoading = true;
      try {
        const valid = await this.$refs.formRef.validate();
        if (!valid) {
          return false;
        }

        if (this.dialogType == "create") {
          await createInfo(this.modelForm);
        } else {
          await editInfo(this.modelForm);
        }
        this.dialogVisible = false;
        this.$emit("success");
      } finally {
        this.submitLoading = false;
      }
    }
  },
  created() {
    this.submitFunc = debounce(this.submitForm, 300, {
      leading: true,
      trailing: false
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Paper/HandsOn/DialogForm.vue